(function () {
  'use strict';

  var GAP = 8;

  function normalizePlateFilename(filename) {
    return filename
      .replace(/%20/gi, ' ')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function plateStyleMatches(filename, style) {
    var normalizedFilename = normalizePlateFilename(filename);
    var normalizedStyle = normalizePlateFilename(style);
    var stylePrefix = 'style ' + normalizedStyle;

    return normalizedFilename === stylePrefix || normalizedFilename.indexOf(stylePrefix + ' ') === 0;
  }

  function getPlateOrder(filename) {
    var normalizedFilename = filename.replace(/%20/gi, ' ');
    var match = normalizedFilename.match(/(\d+)(?!.*\d)/);

    return match ? parseInt(match[1], 10) : Number.MAX_SAFE_INTEGER;
  }

  function comparePlateElements(first, second) {
    var orderDifference = getPlateOrder(first.dataset.plateFilename || '') - getPlateOrder(second.dataset.plateFilename || '');

    if (orderDifference !== 0) return orderDifference;

    return (first.dataset.plateFilename || '').localeCompare(second.dataset.plateFilename || '');
  }

  function sortPlateElements(container, selector) {
    if (!container) return;

    Array.from(container.querySelectorAll(selector))
      .sort(comparePlateElements)
      .forEach(function (element) {
        container.appendChild(element);
      });
  }

  function initGallery(galleryEl) {
    var panels   = galleryEl.querySelectorAll('.product-gallery__panel');
    var viewport = galleryEl.querySelector('.pg-viewport');
    var list     = galleryEl.querySelector('.pg-list');
    var thumbs   = galleryEl.querySelectorAll('.pg-thumb');
    var prevBtn  = galleryEl.querySelector('.pg-prev');
    var nextBtn  = galleryEl.querySelector('.pg-next');
    var platesMode = galleryEl.dataset.platesMode === 'true';

    if (!panels.length && !thumbs.length) return;

    var offset       = 0;
    var thumbWidth   = 0;
    var visibleCount = 1;
    var total        = thumbs.length;

    function refreshVisibleItems() {
      panels = galleryEl.querySelectorAll('.product-gallery__panel:not([hidden])');
      thumbs = galleryEl.querySelectorAll('.pg-thumb:not([hidden])');
      total = thumbs.length;
    }

    function currentGap() {
      if (!list) return GAP;
      var parsed = parseFloat(window.getComputedStyle(list).columnGap);
      return isNaN(parsed) ? GAP : parsed;
    }

    function computeThumbSize() {
      if (!viewport || !total) return;
      thumbWidth = Math.floor(viewport.offsetWidth - currentGap());
      visibleCount = 1;
      thumbs.forEach(function (t) {
        t.style.width = thumbWidth + 'px';
        t.style.height = thumbWidth + 'px';
      });
    }

    function updateSlider() {
      if (!list) return;
      list.style.transform = 'translateX(-' + (offset * (thumbWidth + currentGap())) + 'px)';
      if (prevBtn) prevBtn.disabled = offset === 0;
      if (nextBtn) nextBtn.disabled = total <= 1 || offset >= total - visibleCount;
    }

    function showPanel(index) {
      panels.forEach(function (p, i) {
        p.classList.toggle('product-gallery__panel--active', i === index);
      });
    }

    function activateThumb(index) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('pg-thumb--active', i === index);
      });
      // Keep active thumb inside the visible window
      if (index < offset) {
        offset = index;
      } else if (index >= offset + visibleCount) {
        offset = index - visibleCount + 1;
      }
      updateSlider();
    }

    function applyPlateStyle(style) {
      if (!platesMode) return;

      var viewer = galleryEl.querySelector('.product-gallery__viewer');
      var thumbList = galleryEl.querySelector('.pg-list');

      galleryEl.querySelectorAll('.product-gallery__panel').forEach(function (panel) {
        panel.hidden = !plateStyleMatches(panel.dataset.plateFilename || '', style);
        panel.classList.remove('product-gallery__panel--active');
      });

      galleryEl.querySelectorAll('.pg-thumb').forEach(function (thumb) {
        thumb.hidden = !plateStyleMatches(thumb.dataset.plateFilename || '', style);
        thumb.classList.remove('pg-thumb--active');
      });

      sortPlateElements(viewer, '.product-gallery__panel');
      sortPlateElements(thumbList, '.pg-thumb');
      refreshVisibleItems();
      offset = 0;

      if (panels.length) showPanel(0);
      if (thumbs.length) activateThumb(0);

      computeThumbSize();
      updateSlider();
    }

    if (platesMode) {
      applyPlateStyle(galleryEl.dataset.defaultPlateStyle || 'H');
      galleryEl.addEventListener('plates:style-change', function (event) {
        applyPlateStyle(event.detail && event.detail.style ? event.detail.style : 'H');
      });
    }

    // Thumb clicks
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        showPanel(i);
        activateThumb(i);
      });
    });

    // Arrow clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (offset > 0) { offset--; updateSlider(); }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (total > 1 && offset < total - visibleCount) { offset++; updateSlider(); }
      });
    }

    // Size on load + resize
    computeThumbSize();
    updateSlider();

    if (typeof ResizeObserver !== 'undefined' && viewport) {
      new ResizeObserver(function () {
        computeThumbSize();
        updateSlider();
      }).observe(viewport);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-gallery').forEach(initGallery);
  });
})();
